<div class="clients-page">

  <div class="lx-page-header">
    <div>
      <p class="lx-page-eyebrow">{{ 'page.users_eyebrow' | translate }}</p>
      <h2 class="lx-page-title">{{ 'page.users_title' | translate }}</h2>
      <p class="lx-page-subtitle">{{ 'page.users_subtitle' | translate }}</p>
    </div>
    <div class="lx-page-actions">
      <span class="users-count-chip" *ngIf="!isLoading && !hasError">
        <span class="material-symbols-outlined">manage_accounts</span>
        {{ totalCount | number }} {{ 'page.users_count' | translate }}
      </span>
      <div class="clients-search-wrap">
        <span class="material-symbols-outlined clients-search-icon">search</span>
        <input
          type="search"
          (input)="onSearch($event)"
          [(ngModel)]="searchValue"
          class="clients-search-input"
          [placeholder]="'ph.search_users' | translate"
        />
      </div>
    </div>
  </div>

  <div class="app-card clients-table-card">
    <div class="lx-table-wrap">
      <table
        mat-table
        [dataSource]="usersArr"
        class="clients-mat-table"
      >
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>{{ 'lbl.uid' | translate }}</th>
          <td mat-cell *matCellDef="let row" class="cell-uid">{{ row?.id }}</td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>{{ 'lbl.name' | translate }}</th>
          <td mat-cell *matCellDef="let row">
            <div class="client-name-cell">
              <div class="client-avatar" [class.client-avatar--admin]="row?.is_admin">
                {{ (row?.name || row?.username || '?').charAt(0).toUpperCase() }}
              </div>
              <div>
                <p class="client-name">{{ row?.name || row?.username }}</p>
                <p class="client-sub">{{ row?.email }}</p>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="username">
          <th mat-header-cell *matHeaderCellDef>{{ 'lbl.username' | translate }}</th>
          <td mat-cell *matCellDef="let row" class="cell-username">&#64;{{ row?.username }}</td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>{{ 'lbl.email' | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row?.email }}</td>
        </ng-container>

        <ng-container matColumnDef="role">
          <th mat-header-cell *matHeaderCellDef>{{ 'lbl.role' | translate }}</th>
          <td mat-cell *matCellDef="let row">
            <span class="status-badge" [class.paid]="row?.is_admin" [class.pending]="!row?.is_admin">
              {{ (row?.is_admin ? 'status.admin' : 'status.staff') | translate }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <span class="material-symbols-outlined row-action-icon">chevron_right</span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (mouseover)="onRowHovered(row)"
          (mouseleave)="handleMouseLeave()"
          (mousedown)="goToDetails(row.id)"
          [class.row-selected]="row === selectedRow"
        ></tr>
      </table>
    </div>

    <div class="lx-empty" *ngIf="!isLoading && !hasError && usersArr.length === 0">
      <div class="lx-empty-icon">
        <span class="material-symbols-outlined">manage_accounts</span>
      </div>
      <h3>{{ 'empty.users' | translate }}</h3>
      <p>{{ 'empty.users_sub' | translate }}</p>
    </div>

    <div class="lx-empty" *ngIf="!isLoading && hasError">
      <div class="lx-empty-icon">
        <span class="material-symbols-outlined">error</span>
      </div>
      <h3>{{ 'empty.users_error' | translate }}</h3>
      <p>{{ 'empty.users_error_sub' | translate }}</p>
      <button class="ud-btn-primary" style="margin-top:12px" (click)="loadUsers()">{{ 'btn.retry' | translate }}</button>
    </div>

    <mat-paginator
      [pageSize]="10"
      [length]="totalCount"
      [pageIndex]="page - 1"
      (page)="changePage($event)"
    ></mat-paginator>
  </div>

</div>
